<div class="wrapper">
  <div class="header">
    <div class="header-content">Delete package?</div>
    <img class="close-image" (click)="cancel()" src="./assets/icons/cancel.svg" />
  </div>
  <div class="content">
    <div class="line1">You’re deleting a '{{ data.packageName }}' package from your account.</div>
    <div class="line2">It’ll remain in orders where it’s still in use, but won’t be available for future orders.</div>
    <div class="line1">Are you sure?</div>
  </div>
  <div class="buttons">
    <div>
      <pdq-button label="Cancel" variant="light" (onClick)="cancel()"></pdq-button>
    </div>
    <div class="second-btn">
      <pdq-button label="Delete" variant="danger" (onClick)="delete()"></pdq-button>
    </div>
  </div>
</div>
